// frontend/admin-portal/src/components/dashboard/TreasurySnapshot.jsx
import React from "react";
import {
  Alert,
  Spinner,
  formatMoney,
  Button,
  Panel,
} from "@fiberhome/shared-ui";
import { useNavigate } from "react-router-dom";

export default function TreasurySnapshot({ slice }) {
  const navigate = useNavigate();
  const { data, loading, error } = slice;

  const baseCurrency = data?.baseCurrency || "USD";
  const accounts = data?.accounts || [];
  const total = accounts.reduce(
    (s, a) => s + (Number(a.currentBalance) || 0),
    0,
  );

  return (
    <Panel
      title="Treasury"
      subtitle={`Base currency · ${baseCurrency}`}
      tone="success"
      actions={
        <Button variant="ghost" size="sm" onClick={() => navigate("/treasury")}>
          Open →
        </Button>
      }
    >
      {loading && (
        <div style={{ textAlign: "center", padding: "1rem 0" }}>
          <Spinner size="sm" />
        </div>
      )}
      {error && <Alert variant="danger">{error}</Alert>}
      {!loading && !error && (
        <>
          <div className="fh-bignum">
            <span className="fh-bignum__value">
              {formatMoney(total, { symbol: baseCurrency })}
            </span>
            <span className="fh-bignum__label">total balance</span>
          </div>

          <div className="fh-treasury-mini">
            {accounts.slice(0, 4).map((a) => (
              <div className="fh-treasury-mini__row" key={a.id}>
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="fh-treasury-mini__dot"
                    style={{ background: a.color || "#0d6efd" }}
                  />
                  <span style={{ fontSize: 13 }}>{a.name}</span>
                </div>
                <span className="fh-treasury-mini__amount">
                  {formatMoney(a.currentBalance, { symbol: a.currency })}
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </Panel>
  );
}
